import { IMemberPermissions, IMemberSettings, IMemberVisualizationSettings, ICustomFields, IAiKeyListItem, IRecordPermission } from '@/bundles/Members/interfaces/IMemberSettings';
import { Nullable } from '@/utils/types';
import { BaseArangoModel } from '@/bundles/App/models/BaseArangoModel';
import { OpexDisplayEnum } from '@/bundles/Members/enums';

export class MemberSettings extends BaseArangoModel implements IMemberSettings {
  device_tokens: string[];
  featuredSets: string[];
  member: number;
  permissions: IMemberPermissions;
  annual_goal: Nullable<number>;
  opex_display: OpexDisplayEnum;
  focus_area: Nullable<any>;
  visualization_settings: Nullable<IMemberVisualizationSettings>;
  custom_fields: ICustomFields;
  ai_credentials: IAiKeyListItem[];
  record_permissions: IRecordPermission[];
  _rev: string;

  constructor (data: IMemberSettings) {
    super(data);
    this.device_tokens = data.device_tokens;
    this.featuredSets = data.featuredSets;
    this.member = data.member;
    this.permissions = data.permissions;
    this.annual_goal = data.annual_goal;
    this._rev = data._rev;
    this.opex_display = data.opex_display;
    this.focus_area = data.focus_area || null;
    this.visualization_settings = data.visualization_settings || null;
    this.ai_credentials = data.ai_credentials || [];
    this.record_permissions = data.record_permissions || [];
    this.custom_fields = data.custom_fields || {
      comparable: null,
      // TODO: add other sources
      company: null,
      contact: null,
      deal: null,
      property: null,
      availability: null,
      pipeline: null,
      occupier: null,
      eblast: null,
      marketingCampaign: null,
      signList: null,
      request: null,
      pressrelease: null,
      project: null,
      requirement: null,
    };
  }
}
